import { catchError } from "rxjs/operators";
import { throwError, Observable } from "rxjs";
import {
  HttpClient,
  HttpBackend,
  HttpErrorResponse,
} from "@angular/common/http";
import { environment } from "src/environments/environment";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class MenuService {
  token: string;

  displayedColumns: string[] = ["no", "name", "actions"];

  constructor(
    private http: HttpClient,
    private httpClient: HttpClient,

    handler: HttpBackend
  ) {
    this.httpClient = new HttpClient(handler);
    this.token = localStorage.getItem("currentClient");
  }

  handleError(error: HttpErrorResponse) {
    return throwError(error);
  }

  get(): Observable<any> {
    return this.http.get("/api/menus").pipe(catchError(this.handleError));
  }

  searchByName(name): Observable<any> {
    return this.http
      .get("/api/menus/name/" + name)
      .pipe(catchError(this.handleError));
  }

  // getParentMenus(): Observable<any> {
  //   return this.http
  //     .get('/api/menus/parent-menus')

  //     .pipe(catchError(this.handleError));
  // }

  getParentMenus(): Observable<any> {
    return this.http
      .get("/api/menus/parent-menus-has-sub-menu")

      .pipe(catchError(this.handleError));
  }

  saveMenus(payload): Observable<any> {
    return this.http
      .post("/api/menus", payload)

      .pipe(catchError(this.handleError));
  }
  updateMenus(payload): Observable<any> {
    return this.http
      .put("/api/menus", payload)

      .pipe(catchError(this.handleError));
  }
  deleteMenus(payload): Observable<any> {
    return this.http
      .delete("/api/menus" + "/" + payload)

      .pipe(catchError(this.handleError));
  }
}
